import Server from '../common/server';
import { Toast } from 'antd-mobile';
import { extendObservable, action } from 'mobx';
import utils from '../../src/common/utils'

class Store {
  constructor(props){
    extendObservable(this, {
      loaded: false,
      parentId: 1,
      topCat: '', // 一级分类 ID
      secondCat: '', // 二级分类 ID
      thirdCat: 0, // 三级分类 ID
      deep: 1,
      totalCats: [],  // 全部全部一二级分类
      topCatList: [], // 一级分类下的全部二级分类
      subCatList: [{ // 二级分类下的全部三级分类
        catId: 0,
        deep: 3,
        title: '全部资源',
      }],
      activeSecondTab: 0, //num, 二级分类Tab 当前索引
      pageTitle: '', // 当前总分类标题，加载链接参数上提供给客户端使用
    })
  }
  
  clearData(){
    var me = this;
    me.subCatList = [{
      catId: 0,
      deep: 3,
      title: '全部资源'
    }];
    me.loaded = false;
  }

  // 初次加载数据
  loadData(){
    const me = this;
    me.deep = utils.getParamFromURL('deep') ? utils.getParamFromURL('deep') : '';
    me.topCat = utils.getParamFromURL('superId') ? utils.getParamFromURL('superId') : '';
    me.secondCat = utils.getParamFromURL('subCatId') ? utils.getParamFromURL('subCatId') : '';
    me.loadTopCats();
    me.loadSubCats();
  }

  // 获取总分类
  loadAllCats(callback){
    var me = this;
    Server.GetAllCategory(function(res){
      // console.log('获取全部分类');
      // console.log(res);
      if(res.code === 200 && res.data){
        me.totalCats = res.data.list;
        me.loaded = true;
      }else{
        Toast.info('信息获取失败！',3);
        console.error('信息获取失败！');
      }
      callback && callback();
    })
  }

  // 获取二级分类
  loadTopCats(callback){
    var me = this;
    var catArgs = {
      parentId : me.topCat,
    };
    
    Server.GetSubCat(catArgs,function(res){
      if(res.data.info) me.pageTitle = res.data.info.name;
      if(res.data.subList.length > 0){
        var list = res.data.subList.map((item, index)=>{
          return {
            title: item.name,
            deep: item.deep,
            catId: item.categoryId
          }
        });
        if(me.deep === 1 || me.secondCat === 0){
          list.unshift({
            catId: 0,
            deep: 1,
            title: '全部',
          })
        }
        me.topCatList = list;
        console.log('二级分类:');
        console.log(JSON.stringify(me.topCatList));
      }
      callback && callback();
    })
  }

  // 获取三级分类
  loadSubCats(callback){
    var me = this;
    var args = {
      parentId : me.secondCat,
    }
    
    me.thirdCat = 0;
    if(me.secondCat === 0) return;
    Server.GetSubCat(args, function(res){
      me.loaded = true;
      me.subCatList = [{
        catId: 0,
        deep: 3,
        title: '全部资源',
      }];
      if(res.data.subList.length > 0){
        var list = res.data.subList.map((item, index)=>{
          return {
            title: item.name,
            deep: item.deep,
            catId: item.categoryId,
          }
        });
        me.subCatList = me.subCatList.concat(list) ;
        console.log('三级分类:');
        console.log(JSON.stringify(me.subCatList));
      }
      callback && callback();
    })
  }

  // 切换二级分类时，更新三级分类
  selectSecondCat = action((id,callback)=>{
    var me = this;
    me.loaded = false;
    me.subCatList = [{
      catId: 0,
      deep: 3,
      title: '全部资源',
    }];
    var args = {
      parentId : id,
    }
    me.thirdCat = 0;
    if(me.secondCat === 0) return;
    Server.GetSubCat(args, function(res){      
      me.loaded = true;      
      if( res.data.subList.length > 0){
        var list = res.data.subList.map((item, index)=>{
          return {
            title: item.name,
            deep: item.deep,
            catId: item.categoryId,
          }
        });      
        me.subCatList = me.subCatList.concat(list) ;
      }
      callback && callback();
    })
  })

  // 切换tab时, 更新分类id
  switchTab(data){
    var me = this;
    // console.log('切换分类');
    me.topCat = data.topCat ? data.topCat : me.topCat;
    me.secondCat = data.secondCat ? data.secondCat : me.secondCat;
    me.thirdCat = data.thirdCat || 0;
  }

  // 获取栏目列表 
  // 通过store子分类变化触发子组件参数变化，在子组件中重新加载数据，不在store中获取

}
const store = new Store();
export default store;